import { selectIsCampaignPerformanceAlertsHistoryFeatureFlagOn } from 'core/userContext';
import { AlertsHistoryBadge } from 'modules/campaigns/lib/components/AlertsHistoryBadge';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Badge } from 'ui/badge';
import { spacing } from 'ui/theme';

import { TableCell } from '../CampaignIndexTable.styles';
import { BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES } from '../constants';
import { GraphQLCampaign } from '../domainTypes';

const AlertsHistoryBadgeContainer = styled.div`
  margin-left: ${spacing.quarter};
`;

type CampaignStatusTableCellProps = {
  campaign: GraphQLCampaign;
  hasRecentTriggeredAlerts?: boolean;
  onViewAlerts: () => void;
};

export const CampaignStatusTableCell = ({
  campaign,
  hasRecentTriggeredAlerts,
  onViewAlerts,
}: CampaignStatusTableCellProps) => {
  const statusBadgeVariant = BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES[campaign.campaignState];
  const isCampaignPerformanceAlertsHistoryEnabled = useSelector(
    selectIsCampaignPerformanceAlertsHistoryFeatureFlagOn,
  );

  return (
    <TableCell data-test="campaign-index-state-cell">
      <div>
        {statusBadgeVariant ? (
          <Badge variant={statusBadgeVariant}>{campaign.campaignState}</Badge>
        ) : (
          campaign.campaignState
        )}
      </div>
      {isCampaignPerformanceAlertsHistoryEnabled && hasRecentTriggeredAlerts && (
        <AlertsHistoryBadgeContainer>
          <AlertsHistoryBadge onClick={onViewAlerts} />
        </AlertsHistoryBadgeContainer>
      )}
    </TableCell>
  );
};
